import {enableProdMode, LOCALE_ID, StaticProvider} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {
  ApplicationCompileTimeSettings,
  ApplicationVersion,
  INVITE_AUTH_TOKEN,
  ResourceUtils,
  VERSION,
} from '@lifeislife/lifeislife-domain';
import {forkJoin, of} from 'rxjs';
import {APP_BASE_HREF, PlatformLocation, registerLocaleData} from '@angular/common';
import {Settings} from 'luxon';
import '@angular/localize/init';
import localeFr from '@angular/common/locales/fr';

const appVersion: ApplicationVersion = {
  version: VERSION,
};
const frontCompileTimeAppConfig: ApplicationCompileTimeSettings = {
  config: environment.defaultConfig,
  switches: environment.defaultSwitches,
  authConfig: environment.authConfig,
};
if (environment.production) {
  enableProdMode();
}
//
Settings.defaultLocale = 'fr';
registerLocaleData(localeFr);


forkJoin(
  of(null),
).subscribe(results => {
  const inviteCode = ResourceUtils.getQueryStringParam('invite_token');

  const providers: StaticProvider[] = [
    {provide: ApplicationVersion, useValue: appVersion},
    {provide: ApplicationCompileTimeSettings, useValue: frontCompileTimeAppConfig},
    {provide: LOCALE_ID, useValue: 'fr'},
    {
      provide: APP_BASE_HREF,
      useFactory: (platformLocation: PlatformLocation) => platformLocation.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
  ];
  if (inviteCode != null) {
    providers.push({
      provide: INVITE_AUTH_TOKEN,
      useValue: inviteCode,
    });
  }

  platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch(err => console.error(err));

});

